import { render, staticRenderFns } from "./QuizOption.vue?vue&type=template&id=bf7c72ca&scoped=true&lang=pug"
import script from "./QuizOption.vue?vue&type=script&lang=ts"
export * from "./QuizOption.vue?vue&type=script&lang=ts"
import style0 from "./QuizOption.vue?vue&type=style&index=0&id=bf7c72ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c72ca",
  null
  
)

export default component.exports